import { Component } from 'react';
import LogoAlt from '../assets/logo_alt.png';
import TripWire from '../assets/tripwire.png';
import { Link } from 'react-router-dom';
import { ScrollToView } from '../tools/Helpers';
import CookieConsent from './CookieConsent';

interface MenuMessage {
  url: string;
  title: string;
  attr_title: string;
  classes: any;
  target: string;
}

interface FooterProps {
  data: {
    footer: MenuMessage[];
    esrb: string;
    legal: string;
    isReady: boolean;
  };
}

export class Footer extends Component<FooterProps> {
  constructor(props: any) {
    super(props);
    this.state = {
      active: false,
    };
  }

  render() {
    const { footer, esrb, legal, isReady } = this.props.data;
    return (
      <>
        <footer>
          <div className="container-xl">
            <div className="d-md-flex justify-content-between">
              <div>
                <a href="/" className="brand-logo">
                  <img src={LogoAlt} className="img-fluid" alt="Nightfall - Home" />
                </a>
                {isReady && (
                  <nav className="d-md-flex align-items-center mt-3">
                    {footer &&
                      footer.map((nav: MenuMessage, index: number) =>
                        nav.classes && nav.classes[0] === 'scroll' ? (
                          <Link
                            key={index}
                            className="link"
                            to={nav.url}
                            onClick={() => ScrollToView(nav.attr_title ? nav.attr_title : nav.title)}>
                            {nav.title}
                          </Link>
                        ) : (
                          <Link
                            key={index}
                            className="link"
                            to={nav.url}
                            {...(nav.target ? { target: '_blank', rel: 'noopener noreferrer' } : {})}>
                            {nav.title}
                          </Link>
                        ),
                      )}
                  </nav>
                )}
                <div className="legal d-none d-md-block">{legal}</div>
              </div>
              <div className="legal-links text-end">
                <div className="legal-logos mt-3 d-flex align-items-center justify-content-between">
                  <a
                    className="item me-2"
                    href="https://www.tripwireinteractive.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="TRIPWIRE">
                    <img className="img-fluid" src={TripWire} alt="TRIPWIRE" />
                  </a>
                  <span className="item">
                    <img className="img-fluid border" src={esrb} alt="ESRB" />
                  </span>
                </div>
              </div>
            </div>
            <div className="legal mt-4 d-md-none">{legal}</div>
          </div>
        </footer>
        <CookieConsent />
      </>
    );
  }
}
export default Footer;
